<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="800px"
  >
    <v-card>
      <v-card-title>
        Se connecter en tant que...
        <v-spacer></v-spacer>
        <v-btn icon @click="isOpened = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0" v-if="isOpened">
        <v-row no-gutters justify="center" align="center" class="py-6" v-if="isFetchingUsers">
          <v-progress-circular indeterminate color="accent" />
        </v-row>
        <v-row no-gutters justify="center" align="center" class="py-6" v-else-if="!flavoredUsers.length">
          Aucun utilisateur pour ce client
        </v-row>
        <v-list v-else>
          <template v-for="(user, index) in flavoredUsers">
            <v-list-item :key="`user-${index}`">
              <v-list-item-content>
                <v-list-item-title>
                  {{ user.firstname }} {{ user.lastname }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="user.email">
                  {{ user.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="ma-0" v-if="user.spaces.length === 1">
                <v-btn
                  class="n-small-btn n-primary-btn"
                  :href="getUserSpaceSsoUrl(user.spaces[0])"
                  target="_blank"
                >
                  {{ user.spaces[0].name }}
                  <v-icon right class="ml-2">open_in_new</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action class="ma-0" v-if="user.spaces.length > 1">
                <v-menu rounded>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="n-small-btn n-secondary-btn"
                    >
                      Plusieurs espaces
                      <v-icon right class="ml-1">expand_more</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <template v-for="(space, spacesIndex) in user.spaces">
                      <v-list-item
                        :key="`user-${index}-space-${spacesIndex}`"
                        :href="getUserSpaceSsoUrl(space)"
                        target="_blank"
                      >
                        {{ space.name }}
                        <v-spacer />
                        <v-icon class="ml-2">open_in_new</v-icon>
                      </v-list-item>
                      <v-divider v-if="spacesIndex + 1 < user.spaces.length" :key="`user-${index}-space-${spacesIndex}-divider`" />
                    </template>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < users.length" :key="index" />
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    isFetchingUsers: true,
    users: [],
  }),

  props: {
    value: Boolean,
    client: {
      type: Object,
      required: false,
    },
  },

  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) {
        return this.$emit(`input`, isOpened);
      },
    },
    flavoredUsers() {
      return _.chain(this.users)
        .map(user => ({
          ...user,
          $searchString: _.toLower(`
            ${user.firstname} ${user.lastname} ${user.username || ``} ${user.email || ``}
          `),
        }))
        .sortBy([`firstname`, `lastname`])
        .value();
    },
  },

  methods: {
    ...mapActions(`ui/indeegoSettingsClients`, [
      `fetchClientUsersWithSpaces`,
    ]),
    async fetchUsers() {
      this.isFetchingUsers = true;
      this.users = await this.fetchClientUsersWithSpaces(this.client.id);
      this.isFetchingUsers = false;
    },
    initOpen() {
      this.fetchUsers();
    },
    getUserSpaceSsoUrl(space) {
      let ssoUrl = `${space.slugUrl}/sso?token=${space.ssoToken}&logout=1`;

      if (ssoUrl.indexOf(`http:`) !== 0) {
        const protocol = window.location.protocol; // eslint-disable-line
        ssoUrl = `${protocol}//${ssoUrl}`;
      }

      return ssoUrl;
    },
  },

  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initOpen();
      }
    },
  },

  components: {
  },
};
</script>

<style lang="scss" scoped>
</style>
